import React from "react";
import RelevantLinkBlock from "../fragments/RelevantLinkBlock";
import GalleryCarousel from "../fragments/GalleryCarousel";
import ContactLink from "../fragments/ContactLink";


export default function Article8() {
    const relevantUrls = [
        "/blog/7",
        "/vehicleOrder/catalog?vehicleCategory=CHN_ORDER",
        "/vehicleOrder/pricing",
        "/loan",
        "/listing",
    ];

    const carouselImages = [
        { src: "/pictures/blog/geelyGalaxyM9/photo_2025-09-20 23.41.16.jpeg",
            alt: "Geely Galaxy M9, серый цвет, вид спереди-сбоку в студии",
            caption: "Экстерьер: серый кузов и светодиодная оптика" },
        { src: "/pictures/blog/geelyGalaxyM9/photo_2025-09-20 23.41.20.jpeg",
            alt: "Geely Galaxy M9, чёрный цвет, вид спереди-сбоку, студийный свет",
            caption: "Экстерьер: чёрный силуэт и непрерывная LED-линия" },
        { src: "/pictures/blog/geelyGalaxyM9/photo_2025-09-21 00.17.22.jpeg",
            alt: "Панель Geely Galaxy M9 с широким дисплеем на всю торпедо",
            caption: "Интерьер: панорамный дисплей и аккуратная эргономика" },
        { src: "/pictures/blog/geelyGalaxyM9/photo_2025-09-21 00.17.25.jpeg",
            alt: "Передние сиденья Geely Galaxy M9, светлая кожа, вид сбоку",
            caption: "Салон: светлая кожа, удобная посадка" },
        { src: "/pictures/blog/geelyGalaxyM9/photo_2025-09-21 00.17.27.jpeg",
            alt: "Кресло водителя Geely Galaxy M9, перфорация и контурная прострочка",
            caption: "Комфорт: профильные кресла и тонкая прострочка" },
        { src: "/pictures/blog/geelyGalaxyM9/photo_2025-09-21 00.17.30.jpeg",
            alt: "Панорамная крыша Geely Galaxy M9, два стеклянных модуля",
            caption: "Свет: панорамная крыша для двух рядов" },
        { src: "/pictures/blog/geelyGalaxyM9/photo_2025-09-21 00.17.33.jpeg",
            alt: "Второй ряд Geely Galaxy M9: раздельные кресла-капитаны с подлокотниками",
            caption: "Второй ряд: раздельные кресла-капитаны" },
    ];

    return (
        <div className="site-section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 order-lg-1">
                        <h2 className="mb-3">Geely Galaxy M9 — нашумевший флагман. <br/>Технологии + комфорт + скорость под ваши сценарии ⚙️</h2>

                        <div style={{textAlign: "justify"}}>
                            <p><strong>Коротко о сути:</strong></p>
                            <ul>
                                <li>⚡ <strong>Динамика:</strong> 0–100 км/ч — <strong>4,5 с</strong>.</li>
                                <li>🔋 <strong>Суммарно:</strong> до <strong>707 л.с.</strong> (1.5T 163 л.с. + три
                                    электромотора).
                                </li>
                                <li>🔀 <strong>Трансмиссия:</strong> <strong>3‑ступенчатая DHT</strong>.</li>
                                <li>🧠 <strong>DHT‑режимы (4):</strong> EV / последовательный / параллельный / прямой
                                    привод ДВС (эффективен на &gt;40 км/ч).
                                </li>
                                <li>🛞 <strong>Привод:</strong> полный, электропривод всех колёс.</li>
                                <li>🪄 <strong>Манёвренность:</strong> «танковый разворот».</li>
                                <li>🧊 <strong>Комфорт:</strong> воздушная подвеска, тише и мягче на холодных дорогах.
                                </li>
                                <li>📐 <strong>Размеры:</strong> 5205×1999×1800 мм; база 3030 мм — реально просторный
                                    салон.
                                </li>
                                <li>🧳 <strong>Масса/топливо/батарея/шины:</strong> 2530 кг; бак 60 л; батарея 41,46
                                    кВт·ч; шины 255/50 R20.
                                </li>
                                <li>🚀 <strong>Макс. скорость:</strong> 210 км/ч.</li>
                                <li>🪑 <strong>Интерьер:</strong> кожа, премиальные материалы.</li>
                            </ul>

                            <div className="my-4">
                                <GalleryCarousel images={carouselImages}/>
                            </div>

                            <h4 className="mt-4">Почему вокруг него шум</h4>
                            <ul>
                                <li><strong>Баланс «хочу» и «надо».</strong> Спорткар по ускорению, семейный по
                                    пространству, экономный в городе.
                                </li>
                                <li><strong>Технологии под реальную жизнь.</strong> EV в пробках, параллель — когда
                                    нужно ускорение, прямой привод — на трассе.
                                </li>
                                <li><strong>Не ждать до весны.</strong> Автомобиль уже в пути и будет на днях —
                                    принимаем заявки.
                                </li>
                            </ul>

                            <h3 className="mt-4">Оффер</h3>

                            <p>Мы заранее привезли <strong>Galaxy M9</strong> одним из первых — <em>чтобы вы сели за
                                руль без ожиданий</em> 🔑</p>
                            <div className="mt-3">
                                <ContactLink>Свяжитесь с нами удобным для вас способом →</ContactLink>
                                <span> — варианты в наличии, сроки на днях, помощь с кредитом/лизингом.</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 order-lg-2">
                        <RelevantLinkBlock relevantUrls={relevantUrls}/>
                    </div>
                </div>
            </div>
        </div>
    );
}